import {
  GET_PAYMENT_CARD_PARAMS_FAILURE,
  GET_PAYMENT_CARD_PARAMS_SUCCESS,
  RESET_PAYMENT_CARD_PARAMS,
  CREATE_NEW_CUSTOMER_ORDER_REQUESTED,
  CREATE_NEW_CUSTOMER_ORDER_SUCCESS,
  CREATE_NEW_CUSTOMER_ORDER_FAILURE,
  UPGRADE_EXISTING_ACCOUNT_FAILURE,
  UPGRADE_EXISTING_ACCOUNT_SUCCESS,
  UPGRADE_EXISTING_ACCOUNT_REQUESTED,
  GET_EXISTING_PAYMENT_CARD_DETAILS_REQUESTED,
  GET_EXISTING_PAYMENT_CARD_DETAILS_SUCCESS,
  GET_PAYMENT_CARD_PARAMS_REQUESTED,
  SET_ZUORA_IFRAME_LOADING
} from '../actionCreators/paymentActions';
import { RESET_STATE } from '../actionCreators/generalActions';
import { COUNTRY_UPDATE } from '../actionCreators/locationActions';

const initialState = {
  paymentCardParamsLoading: false,
  paymentCardParamsLoaded: false,
  clientPaymentParams: null,
  error: '',
  orderCreating: false,
  orderCreated: false,
  succeed: '',
  paymentRef: '',
  existingPaymentDetails: null,
  upgradeExistingVsdUser: false,
  upgradeExistingVsdUserLoading: false,
  upgradeExistingVsdUserLoaded: false,
  checkingForExistingUser: true,
  isPaymentCardViewLoading: true,
  zuoraIframeLoading: true
};

export default function paymentsReducer(state = initialState, action) {
  switch (action.type) {
    case GET_EXISTING_PAYMENT_CARD_DETAILS_REQUESTED: {
      return {
        ...state,
        checkingForExistingUser: true,
        existingPaymentDetails: null
      };
    }

    case GET_EXISTING_PAYMENT_CARD_DETAILS_SUCCESS: {
      return {
        ...state,
        existingPaymentDetails: action.payload || null,
        checkingForExistingUser: false,
        isPaymentCardViewLoading: false
      };
    }

    case UPGRADE_EXISTING_ACCOUNT_REQUESTED: {
      return {
        ...state,
        upgradeExistingVsdUserLoading: true,
        upgradeExistingVsdUserLoaded: false
      };
    }

    case UPGRADE_EXISTING_ACCOUNT_SUCCESS: {
      return {
        ...state,
        upgradeExistingVsdUser: true,
        upgradeExistingVsdUserLoading: false,
        upgradeExistingVsdUserLoaded: true
      };
    }

    case UPGRADE_EXISTING_ACCOUNT_FAILURE: {
      return {
        ...state,
        error: action.error,
        upgradeExistingVsdUser: false,
        upgradeExistingVsdUserLoading: false,
        upgradeExistingVsdUserLoaded: true
      };
    }

    case GET_PAYMENT_CARD_PARAMS_REQUESTED: {
      return {
        ...state,
        paymentCardParamsLoading: true,
        paymentCardParamsLoaded: false,
        clientPaymentParams: null
      };
    }

    case GET_PAYMENT_CARD_PARAMS_FAILURE: {
      return {
        ...state,
        error: action.error,
        paymentCardParamsLoading: false,
        paymentCardParamsLoaded: true
      };
    }

    case GET_PAYMENT_CARD_PARAMS_SUCCESS: {
      return {
        ...state,
        paymentCardParamsLoading: false,
        paymentCardParamsLoaded: true,
        clientPaymentParams: action.payload.clientPaymentParams
      };
    }

    case RESET_PAYMENT_CARD_PARAMS: {
      return {
        ...state,
        paymentCardParamsLoading: false,
        paymentCardParamsLoaded: false,
        clientPaymentParams: null
      };
    }

    case CREATE_NEW_CUSTOMER_ORDER_REQUESTED: {
      return {
        ...state,
        orderCreating: true,
        orderCreated: false,
        paymentRef: action.paymentRef
      };
    }

    case CREATE_NEW_CUSTOMER_ORDER_SUCCESS: {
      return {
        ...state,
        orderCreating: false,
        orderCreated: true,
        succeed: action.succeed
      };
    }

    case CREATE_NEW_CUSTOMER_ORDER_FAILURE: {
      return {
        ...state,
        error: action.error,
        orderCreating: false,
        orderCreated: true
      };
    }

    case COUNTRY_UPDATE: {
      return {
        ...state,
        clientPaymentParams: null
      };
    }

    case SET_ZUORA_IFRAME_LOADING: {
      return {
        ...state,
        zuoraIframeLoading: action.payload
      };
    }

    case RESET_STATE: {
      return {
        ...initialState
      };
    }

    default:
      return state;
  }
}
